import { FunctionalComponent, h } from 'preact';

import { i18nTranslate } from 'common/helper/i18n/translate';
import { BuildingReviewAgentSwitchTemplatePropsInterface } from 'common/module/building-review/agent-switch/template-props.interface';

export const BuildingReviewAgentSwitchTemplate: FunctionalComponent<BuildingReviewAgentSwitchTemplatePropsInterface> = (
  props
) => {
  return (
    <div className='switch switch2'>
      <span
        className={`switch_link switch2__link ${props.isSaleCategoryActive ? 'switch_link-active' : ''}`}
        data-qs='switch'
        onClick={props.onClickForRent}
      >
        <span>{i18nTranslate('Sales')}</span>
      </span>
      <span
        className={`switch_link switch2__link ${props.isSaleCategoryActive ? '' : 'switch_link-active'}`}
        data-qs='switch'
        onClick={props.onClickForSale}
      >
        <span>{i18nTranslate('Rental')}</span>
      </span>
      <div
        className={`switch_slider switch2__slider ${props.isSaleCategoryActive ? '' : 'switch_slider-sliding'}`}
        data-qs='switch-slider'
      />
    </div>
  );
};
